module.exports = {
    beforeCreate() {},
    data() {
      return {};
    },
    methods: {
      getPlainText_mx(richCont) {
        function convertIdeogramToNormalCharacter(val) {
          const arrEntities = {
            lt: "<",
            gt: ">",
            nbsp: " ",
            amp: "&",
            quot: '"',
          };
          return val.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
            return arrEntities[t];
          });
        }
  
        const str = richCont;
        let value = richCont;
        if (richCont) {
          // 方法一：
          value = value.replace(/\s*/g, ""); //去掉空格
          value = value.replace(/<[^>]+>/g, ""); //去掉所有的html标记
          value = value.replace(/↵/g, ""); //去掉所有的↵符号
          value = value.replace(/[\r\n]/g, ""); //去掉回车换行
          value = value.replace(/&nbsp;/g, ""); //去掉空格
          value = convertIdeogramToNormalCharacter(value);
          return value;
  
          // 方法二：
          // value = value.replace(/(\n)/g, "");
          // value = value.replace(/(\t)/g, "");
          // value = value.replace(/(\r)/g, "");
          // value = value.replace(/<\/?[^>]*>/g, "");
          // value = value.replace(/\s*/g, "");
          // value = convertIdeogramToNormalCharacter(value);
          // return value;
        } else {
          return null;
        }
      },
  
      /**
       * 动态拼接用的方法 增加引号 解决了圆括号的的冲突
       * @param baseurl
       * @param src
       * @returns {string|*}
       */
      imageBgSrc_mx(baseurl, src) {
        if (!src && !baseurl) {
          console.error("错误的入参");
          return baseurl+src;
        }
        if (src.indexOf("http") > -1) return `url("${src}")`;
        return  `url("${baseurl}${src}")`;
      },
      sliceTimeString_mx:(val,num)=>{
        if(val) {
          return val.slice(0,num || 10)
       }
      },
      changeStyle_mx:(htmlstr)=> {
        if(!htmlstr){
            return
        }
        let newContent= htmlstr.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;"').replace(
          /style="/gi,
          'style="max-width:100%;'
        );
           return newContent;
         
       }, 
       //埋点
       basePoint_mx(fid){
        console.log(fid)
        if(fid==0){
          console.info("不需要埋点")
          return 
        }
        let datas = {
          fid: fid,
          member_id: uni.getStorageSync("token"),
        };
        console.log(datas)
        this.$https
          .getRequest(
            "/apiApplet/frontMenuPoint",
            { params: datas },
            true,
            true,
            "endCodes",
            "endCodes"
          ).then(res=>{})
       }
       
    },
  };
  


// WEBPACK FOOTER //
// ./src/mixin/g.mixin.js